module.exports = __webpack_public_path__ + "static/media/tournament.e21626a1.svg";